import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Competitor, CreateCompetitorRequest } from '@seo/types';
import { apiPost } from '@/lib/api';

export function useCreateCompetitor() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateCompetitorRequest) =>
      apiPost<Competitor>('/v1/competitors', input, {
        headers: { 'idempotency-key': crypto.randomUUID() },
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['competitors'] });
    },
  });
}
